"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "AccountDropdown", {
  enumerable: true,
  get: function get() {
    return _CommonChrome.AccountDropdown;
  }
});

_Object$defineProperty(exports, "AccountMenuItem", {
  enumerable: true,
  get: function get() {
    return _CommonChrome.AccountMenuItem;
  }
});

_Object$defineProperty(exports, "AppSwitcher", {
  enumerable: true,
  get: function get() {
    return _CommonChrome.AppSwitcher;
  }
});

_Object$defineProperty(exports, "Avatar", {
  enumerable: true,
  get: function get() {
    return _CommonChrome.Avatar;
  }
});

_Object$defineProperty(exports, "Content", {
  enumerable: true,
  get: function get() {
    return _CommonChrome.Content;
  }
});

_Object$defineProperty(exports, "ContextConsumer", {
  enumerable: true,
  get: function get() {
    return _CommonChrome.ContextConsumer;
  }
});

_Object$defineProperty(exports, "ContextProvider", {
  enumerable: true,
  get: function get() {
    return _CommonChrome.ContextProvider;
  }
});

_Object$defineProperty(exports, "Logo", {
  enumerable: true,
  get: function get() {
    return _CommonChrome.Logo;
  }
});

_Object$defineProperty(exports, "Nav", {
  enumerable: true,
  get: function get() {
    return _CommonChrome.Nav;
  }
});

_Object$defineProperty(exports, "NavDropdown", {
  enumerable: true,
  get: function get() {
    return _CommonChrome.NavDropdown;
  }
});

_Object$defineProperty(exports, "NavMenuDivider", {
  enumerable: true,
  get: function get() {
    return _CommonChrome.NavMenuDivider;
  }
});

_Object$defineProperty(exports, "NavMenuHeading", {
  enumerable: true,
  get: function get() {
    return _CommonChrome.NavMenuHeading;
  }
});

_Object$defineProperty(exports, "NavMenuItem", {
  enumerable: true,
  get: function get() {
    return _CommonChrome.NavMenuItem;
  }
});

_Object$defineProperty(exports, "NavSearch", {
  enumerable: true,
  get: function get() {
    return _CommonChrome.NavSearch;
  }
});

_Object$defineProperty(exports, "Section", {
  enumerable: true,
  get: function get() {
    return _CommonChrome.Section;
  }
});

exports.mount = exports.mountComponent = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _CommonChrome = _interopRequireWildcard(require("./CommonChrome"));

var _default = _CommonChrome["default"];
exports["default"] = _default;

var mountComponent = function mountComponent(componentName, target) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var Component = _CommonChrome["default"][componentName];

  if (Component) {
    _reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(Component, props), target);
  }
};

exports.mountComponent = mountComponent;

var mount = function mount(target) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(_CommonChrome["default"], props), target);
};

exports.mount = mount;